const Button = ({ text, variant, className = "", ...props }) => {
  let colorClass = "";

  switch (variant) {
    case "outline":
      colorClass = "text-primary bg-transparent border border-btnOutline";
      break;
    case "primary":
      colorClass = "text-white bg-primary";
      break;
    case "secondary":
      colorClass = "text-white bg-secondary";
      break;
    case "blue":
      colorClass = "text-white bg-blue";
      break;
    case "purple":
      colorClass = "text-white bg-purple";
      break;
    case "red":
      colorClass = "text-white bg-redBorder";
      break;
    default:
      colorClass = "";
  }
  return (
    <button
      className={`box-border w-4/5 py-2.5 font-pop text-base font-semibold ${colorClass} ${className}`}
      {...props}
    >
      {text}
    </button>
  );
};

export default Button;
